import ReactOnRails from 'react-on-rails';
import React from 'react';
import Knowledge from '@Pages/Knowledge/index.ssr';
import KnowledgeDetail from '@Pages/KnowledgeDetail/index.ssr';

// application.js側はlazy(...)+Suspenseで登録しているが、React 17(yarn.lock: 17.0.2)の
// renderToStringはlazyの解決状態に関わらず<Suspense>要素そのものに遭遇した時点で
// 無条件に例外を投げる（react-dom 17.0.2 cjs/react-dom-server.browser.development.js:
// 3838-3847の`case REACT_SUSPENSE_TYPE`、「ReactDOMServer does not yet support
// Suspense.」= React error #294、実測で確認。詳細はindex.ssr.tsxのコメント参照）。
// react_on_rails(npm 12.5.2)側のserver_rendered_react_component(react_on_rails gem 13.2.0
// lib/react_on_rails/helper.rb:507-514)はこれをStandardErrorとして拾いPrerenderErrorへ
// ラップするため、knowledge_controller.rbのrescue_fromでCSRへフォールバックすることになる
// (issue #2141)。server-bundle.js経由でこのファイルを後からimportすることで、
// ReactOnRails.registerのMapベースのレジストリ(react-on-rails 12.5.2
// node_package/lib/ComponentRegistry.js: `var registeredComponents = new Map()`)に対して
// 同名キーで「後勝ち上書き」させ、SSR用にのみeager importのコンポーネントへ差し替える
// (courses/PR #2082と同じパターン)。application.js側のlazy登録はクライアント側の
// 初期バンドル肥大化を避けるため変更しない。
//
// KnowledgeDetailはトップレベルだけでなく内部の子（記事本文52件含む）も全てlazy()の
// ため、Detail/List向けの「トップレベルのみeager化」では内部Suspenseが解消できず
// 実際には毎回SSRが失敗しCSRへフォールバックし続けていた(issue #2141、実測で確認)。
// そのため@Pages/Knowledge, @Pages/KnowledgeDetail自体ではなく、内部の子まで
// 静的importで解決する index.ssr.tsx を参照する（詳細は各index.ssr.tsxのコメント参照）。
//
// Detail/List同様、railsContextからcurrentPath（ヘッダーの「会員権の基礎知識」選択中ナビ判定用、
// PR #2082 Point2対応）を渡す。渡さなくてもgetPathResolverがSSR時はcurrent: falseに
// フォールバックしクラッシュはしないが、ハイライトがhydration後まで正しく表示されなくなる。
ReactOnRails.register({
    Knowledge: (props, railsContext) => {
        return <Knowledge {...props} currentPath={railsContext?.pathname} />;
    },
    KnowledgeDetail: (props, railsContext) => {
        return <KnowledgeDetail {...props} currentPath={railsContext?.pathname} />;
    },
});
